import './App.css';
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import MainPage from "./Components/mainPage/MainPage";
import {Routes, Route} from "react-router-dom";
import Categories from "./Components/categories/Categories";
import {Layout} from "./Layout";
import ProductContainer from "./Components/categories/product/ProductContainer";
import Brands from "./Components/brands/brands";
import Info from "./Components/info/Info";
import Delivery from "./Components/info/Delivery";
import Security from "./Components/info/Security";
import Error404 from "./Components/error/error404";
import Account from "./Components/account/Account";
import News from "./Components/news/News";
import SingleNew from "./Components/news/SingleNew";
import Contacts from "./Components/contacts/Contacts";
import Basket from "./Components/ basket/Basket";
import {readUserData} from "./firebase";
import {setUserData} from "./store/UserInfoSlice";
import {orderCounter, setOrder} from "./store/OrderSlice";
import PopUp from "./assets/Components/popUp/PopUp";
import OrderCheckout from "./Components/ basket/OrderСheckout";
import {setHistory, setMethods} from "./store/OrdersHistorySlice";
import OrderSuccess from "./Components/ basket/OrderSuccess";

function App() {
    const dispatch = useDispatch();
    const userId = useSelector(state => state.authUser.userId);
    const [isModale, setIsModale] = useState(false);
    const [text, setText] = useState("");

    const togglePopUp = (toggler, message) => {
        if (toggler) {
            setIsModale(true);
            setText(message);
        } else {
            setIsModale(false);
        }
    }


    useEffect(() => {
        readUserData(userId).then((data) => {
            dispatch(orderCounter(data.ordersCount));
            const ordersObject = data.Order;
            for (let key in ordersObject) {
                dispatch(setOrder(ordersObject[key]));
            }

            const OrdersHistoryArray = data.OrdersHistory;
            const historyObject = [];
            for (let i = 0; i < OrdersHistoryArray.length; i++) {
                historyObject.push(OrdersHistoryArray[i]);
            }

            dispatch(setHistory(historyObject));
            const deliveryMethod = data.deliveryMethod;
            const paymentMethod = data.paymentMethod;
            dispatch(setMethods({deliveryMethod, paymentMethod}));
        });
    }, []);

    return (
        <div className="App">
            {isModale ? <PopUp togglePopUp={togglePopUp} text={text}/> : null}
            <Routes>
                <Route path="/" element={<Layout/>}>
                    <Route index element={<MainPage/>}/>
                    <Route path="categories/*" element={<Categories/>}/>
                    <Route path="categories/:category/:id" element={<ProductContainer togglePopUp={togglePopUp}/>}/>
                    <Route path="brands" element={<Brands/>}/>
                    <Route path="info" element={<Info/>}/>
                    <Route path="delivery" element={<Delivery/>}/>
                    <Route path="basket" element={<Basket/>}/>
                    <Route path="basket/order-checkout" element={<OrderCheckout/>}/>
                    <Route path="basket/success" element={<OrderSuccess/>}/>
                    <Route path="security" element={<Security/>}/>
                    <Route path="news" element={<News/>}/>
                    <Route path="news/:new" element={<SingleNew/>}/>
                    <Route path="contacts" element={<Contacts/>}/>
                    <Route path="account/*" element={<Account/>}/>
                    <Route path="*" element={<Error404/>}/>
                </Route>
            </Routes>
        </div>
    );
}

export default App;
